export { default } from "./changePassword";
